import { Container } from './ProfileIconStyles';
import { UserRound } from 'lucide-react';

const ProfileIcon = ({ onClick }) => {
  return (
    <Container onClick={onClick}>
      <UserRound size={24} strokeWidth={1.2} />
    </Container>
  );
};

export default ProfileIcon;
